module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yuGO1J/tc-custom/9781426832734.jpg?1718169669765",
      "alt": "This image is the cover for the book Border Lord"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Border Lord\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ordered to marry, Laird Lachlan Kerr thought a betrothal to homely, timid Lady Grace Stanton was hardly worth the trouble of protest. Yet, despite everything, he found there was something about her that wasbrave. All his life he had been surrounded by betrayal, and this woman, who believed there was still goodness in him, was special indeed."), _c('br'), _c('br'), _vm._v("Grace knew that the safety of her home depended on her betrothalsigned, sealed and delivered! Lachlan's strength and unexpected care of her were dangerously appealing. She could fall for this man with secrets in his eyes."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sophia James\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Georgette Heyer novels formed Sophia James’s reading tastes as a teenager. But her writing life only started when she was given a pile of Mills & Boons to read after she had had her wisdom teeth extracted! Filled with strong painkillers she imagined that she could pen one, too. Many drafts later Sophia thinks she has the perfect job writing for Harlequin Historical as well as taking art tours to Europe with her husband, who is a painter.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0